type EnvironmentSubdomain = 'www' | 'staging' | 'dev'

const parseEnvSubdomain = (): EnvironmentSubdomain => {
    if (process.env.NEXT_PUBLIC_AWS_POOL === 'us-east-2_oioFbG8q2') return 'www'

    if (process.env.NEXT_PUBLIC_AWS_POOL === 'us-east-2_hTjyLjV4S') return 'staging'

    return 'dev'
}

export default parseEnvSubdomain
